export const SET_MODAL = 'SET_MODAL';
export const REMOVE_MODAL = 'REMOVE_MODAL';
export const SET_ON_CLOSE_CALLBACK = 'SET_ON_CLOSE_CALLBACK';
export const REMOVE_ON_CLOSE_CALLBACK = 'REMOVE_ON_CLOSE_CALLBACK';
export const SET_OPTIONS = 'SET_OPTIONS';
export const REMOVE_OPTIONS = 'REMOVE_OPTIONS';
export const TOGGLE_SUBMIT_CLICK = 'TOGGLE_SUBMIT_CLICK';


// WEBPACK FOOTER //
// ./src/store/modules/modal/mutations.js